import { getErrors as getErrorsSelector } from "@/redux/modules/value/errors/errors.selectors";
import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";

import { $AddressBookModuleName } from "./addressbook.types";

const { isLoading, isSuccessfullyLoaded } = generateDefaultSelectors(
    $AddressBookModuleName
);

const getAddresses = (state: IState) =>
    getApiDataState(state, $AddressBookModuleName)?.data?.addresses || [];

const getErrors = (state: IState) => getErrorsSelector(state);

export { getAddresses, getErrors, isLoading, isSuccessfullyLoaded };
